import { render, staticRenderFns } from "./privacyApply.vue?vue&type=template&id=81c93700&scoped=true"
import script from "./privacyApply.vue?vue&type=script&lang=js"
export * from "./privacyApply.vue?vue&type=script&lang=js"
import style0 from "./privacyApply.vue?vue&type=style&index=0&id=81c93700&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c93700",
  null
  
)

export default component.exports